import React, { FC, useRef } from 'react';

import { Button } from 'devextreme-react/button';
import DataGrid, {
  Column,
  Editing,
  FilterRow,
  Form,
  Pager,
  Paging,
  Popup,
  RequiredRule,
} from 'devextreme-react/data-grid';
import { Item } from 'devextreme-react/form';
import 'devextreme-react/text-area';

import CustomStore from 'devextreme/data/custom_store';

import { AppCard, AppLayoutTop } from '../../../../components/appComponents';
import ClaimsProvider from '../../../../components/claimsBlock';
import { useAuth } from '../../../../context/auth';
import { requestHelper } from '../../../../utils/request-helper';

const TemplateSalaryPage: FC = () => {
  const { getClaims }: any = useAuth();

  const templateSalaryDataStore: any = new CustomStore({
    key: 'id',
    load: (loadOptions: any) => requestHelper('/v1/TemplateSalary', 'get', loadOptions),
    insert: async (values) => {
      await requestHelper('/v1/TemplateSalary', 'post', {
        values: values,
      });
    },

    remove: async (key) =>
      await requestHelper(`/v1/TemplateSalary/${key}`, 'delete', {
        key: key,
      }),

    update: async (key, values) => {
      await requestHelper(`/v1/TemplateSalary/${key}`, 'put', {
        key: key,
        values: values,
      });
    },
  });

  let refGrid = useRef<DataGrid | null>(null);

  return (
    <div className="container-dev">
      <AppLayoutTop title="География">
        <ClaimsProvider claimsBlock={['CanCreateGeography']}>
          <Button width={120} text="Создать" type="default" onClick={() => refGrid.current?.instance.addRow()} />
        </ClaimsProvider>
      </AppLayoutTop>

      <AppCard>
        <DataGrid
          dataSource={templateSalaryDataStore}
          showBorders={false}
          loadPanel={{
            enabled: true,
            text: 'Загрузка',
          }}
          ref={refGrid}
          remoteOperations={true}
          onRowUpdating={(e) => (e.newData = { ...e.oldData, ...e.newData })}
          onInitNewRow={(e) => (e.data = { residentSalary: null, nonResidentSalary: null, comment: '' })}
        >
          <FilterRow visible={true} />

          <Editing
            mode="popup"
            allowUpdating={getClaims(['CanEditGeography'])}
            texts={{
              editRow: 'Просмотр',
            }}
            allowDeleting={getClaims(['CanDeleteGeography'])}
          >
            <Popup title="Просмотр информации" showTitle={true} width={400} height="auto" />
            <Form>
              <Item itemType="group" colCount={2} colSpan={2}>
                <Item dataField="comment" caption="Наименование" colSpan={2}>
                  <RequiredRule message="Заполните поле наименование" />
                </Item>
                <Item dataField="residentSalary" caption="З/П резидента" colSpan={2} editorType="dxNumberBox">
                  <RequiredRule message="Заполните поле З/П резидента" />
                </Item>
                <Item dataField="nonResidentSalary" caption="З/П нерезидента" colSpan={2} editorType="dxNumberBox">
                  <RequiredRule message="Заполните поле З/П нерезидента" />
                </Item>

                {/* <Item dataField="isDeleted" caption="Удалён" colSpan={2} /> */}
              </Item>
            </Form>
          </Editing>

          <Column dataField="comment" caption="Наименование" sortOrder="asc" />
          <Column dataField="residentSalary" caption="З/П резидента" />
          <Column dataField="nonResidentSalary" caption="З/П нерезидента" />
          {/* <Column dataField="isDeleted" caption="Удалён" width={200} /> */}

          <Paging defaultPageSize={15} />
          <Pager showPageSizeSelector={true} allowedPageSizes={[15, 30, 50, 100]} />
        </DataGrid>
      </AppCard>
    </div>
  );
};

export default TemplateSalaryPage;
